<script>
import Layout from "@/router/layouts/main";
import { mapState } from "vuex";
import Avatar from "@/components/widgets/avatar";

export default {
  locales: {
    pt: {
      'My Account': 'Minha Conta',
      'Username': 'Usuário',
      'Name': 'Nome',
      'Email': 'E-mail',
      'Cellphone': 'Celular',
      'Password': 'Senha',
      'Person type': 'Tipo',
      'CPF': 'CPF',
      'CNPJ': 'CNPJ',
      'Document': 'Documento',
    },
    es: {
      'My Account': 'Mi Cuenta',
      'Username': 'Nombre de Usuario',
      'Name': 'Nombre',
      'Email': 'Correo',
      'Cellphone': 'Celular',
      'Person type': 'Tipo',
      'CPF': 'CPF',
      'CNPJ': 'CNPJ',
      'Document': 'Documento',
    }
  },
  components: {
    Layout,
    Avatar
  },
  computed: {
    ...mapState({
      account: state => state.account
    }),
    personKindShort() {
      const p = this.account.user && this.account.user.person;
      const kind = p && p.type;
      if (kind === "legal") {
        return "PJ";
      }
      if (kind === "natural") {
        return "PF";
      }
      return "—";
    },
    documentFieldLabel() {
      const p = this.account.user && this.account.user.person;
      const kind = p && p.type;
      if (kind === "legal") {
        return this.t("CNPJ");
      }
      if (kind === "natural") {
        return this.t("CPF");
      }
      return this.t("Document");
    },
    formattedDocumentNumber() {
      const u = this.account.user;
      const p = u && u.person;
      if (!p || !p.number) {
        return "—";
      }
      return this.formatBrazilianId(p.number, p.type);
    },
  },
  data() {
    return {
    };
  },
  methods: {
    formatBrazilianId(raw, personType) {
      const digits = String(raw || "").replace(/\D/g, "");
      if (personType === "natural" && digits.length === 11) {
        return digits.replace(
          /(\d{3})(\d{3})(\d{3})(\d{2})/,
          "$1.$2.$3-$4"
        );
      }
      if (personType === "legal" && digits.length === 14) {
        return digits.replace(
          /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
          "$1.$2.$3/$4-$5"
        );
      }
      return raw || "—";
    },
  },
  mounted() {
  },
};
</script>

<template>
  <Layout>
    <div class="page-title-box d-md-flex justify-content-between">
      <div>
        <h3>{{ t('My Account') }}</h3>
        <p></p>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-md-4">
            <Avatar></Avatar>
          </div>
          <div class="col-md-8 pt-md-5">
            <div class="row pt-3 pb-0 pl-3 pr-3">
              <div class="col-md-6 text-center-sm">
                <p class="mb-0 text-uppercase font-weight-normal card-title-desc">{{ t('Username') }}</p>
                <p class="mb-3 font-weight-normal notranslate">{{ account.user.username }}</p>
              </div>
              <div class="col-md-6 text-center-sm">
                <p class="mb-0 text-uppercase font-weight-normal card-title-desc">{{ t('Name') }}</p>
                <p class="mb-3 font-weight-normal notranslate">{{ account.user.name }}</p>
              </div>
              <div class="col-md-6 text-center-sm">
                <p class="mb-0 text-uppercase font-weight-normal card-title-desc">{{ t('Email') }}</p>
                <p class="mb-3 font-weight-normal notranslate">{{ account.user.email.address }}</p>
              </div>
              <div class="col-md-6 text-center-sm">
                <p class="mb-0 text-uppercase font-weight-normal card-title-desc">{{ t('Cellphone') }}</p>
                <p class="mb-3 font-weight-normal notranslate">{{ account.user.cellphone }}</p>
              </div>
              <div class="col-md-6 text-center-sm">
                <p class="mb-0 text-uppercase font-weight-normal card-title-desc">{{ t('Person type') }}</p>
                <p class="mb-3 font-weight-normal notranslate">{{ personKindShort }}</p>
              </div>
              <div class="col-md-6 text-center-sm">
                <p class="mb-0 text-uppercase font-weight-normal card-title-desc">{{ documentFieldLabel }}</p>
                <p class="mb-3 font-weight-normal notranslate">{{ formattedDocumentNumber }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>